import { Inject, Injectable, Optional } from '@angular/core';
import {
  MatDateFormats,
  MAT_DATE_LOCALE,
  NativeDateAdapter,
} from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// Map app language codes to Intl locale codes
const LOCALE_MAP: Record<string, string> = {
  cz: 'cs', // Czech: app uses 'cz', Intl uses 'cs'
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    @Optional() private translateService: TranslateService,
  ) {
    super(matDateLocale);

    // Set initial locale
    const initialLang =
      this.translateService?.currentLang ||
      this.translateService?.defaultLang ||
      'en';
    this.setLocale(initialLang);

    // Subscribe to language changes for future updates
    this.translateService?.onLangChange.subscribe(event => {
      this.setLocale(event.lang);
    });
  }

  // Override setLocale to always map app language codes to Intl locale codes
  override setLocale(locale: string): void {
    super.setLocale(LOCALE_MAP[locale] || locale);
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.indexOf('.') > -1) {
      const str = value.split('.');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return new Date(year, month, date);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }

  format(date: Date): string {
    const days = date.getDate();
    const months = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${days < 10 ? '0' + days : days}.${
      months < 10 ? '0' + months : months
    }.${year}`;
  }
}
